import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import InputField from "../../../common/CustomInputField";
import { Oval } from "react-loader-spinner";
import dayjs from "dayjs";
import { Formik } from "formik";
import { addSubOwnerStyle as style } from "./helper";
import MultiSelect from "../../../common/MultiSelect";
import { useTranslation } from "react-i18next";
const AddOwner = ({
  open,
  handleClose,
  handleSubmit,
  handleDelete,
  type,
  id,
  getInitialValues,
  enteries,
  tabType,
  typeList,
  selectedRow,
  validationSchema,
  user,
  selectInsuranceDocument,
  tabName,
  documentName,
  btnLoader,
  insuranceType,
}) => {
  const { translationKey } = selectedRow;
  const { t } = useTranslation();
  const tabNames = ["Shareholdings", "Others", "Corporate Shareholdings"];
  const { type: nameOfType, companyName: selectedCompany } = getInitialValues();

  console.log("first");

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Formik
        enableReinitialize
        validationSchema={validationSchema}
        // initialValues={getInitialValues()}
        initialValues={{
          ...getInitialValues(),
          fixedInterestRate: getInitialValues().fixedInterestRate
            ? new Date(getInitialValues().fixedInterestRate)
            : "",
        }}
        onSubmit={(values) => {
          (async () => {
            const fixedInterestRate =
              values.fixedInterestRate instanceof Date
                ? values.fixedInterestRate.toISOString()
                : values.fixedInterestRate;
            await handleSubmit({
              ...values,
              fixedInterestRate,
            });
            handleClose();
          })();
        }}
      >
        {(formik) => {
          console.log("Formik values:", formik.values);

          return (
            <Box sx={style}>
              <Box
                lg={12}
                sx={{
                  backgroundColor: "color.magentaLight2",
                  padding: "10px",
                  color: "color.brown",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography id="modal-modal-title" pl={3} component="p">
                  {t(translationKey) ||
                    selectedCompany ||
                    nameOfType?.label ||
                    tabName}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    onClick={() => handleClose()}
                    sx={{
                      cursor: "pointer",
                    }}
                    pr={1}
                    variant="h6"
                    component="h2"
                  >
                    <img src="/assets/icons/close-icon.svg" alt="Close" />
                  </Typography>
                </Box>
              </Box>
              <FormControl sx={{ width: "100%", padding: "20px " }}>
                {insuranceType !== "disabled" &&
                  (tabType === "others" ? (
                    <>
                      {type === "owner" && (
                        <MultiSelect
                          className="multiselectss"
                          label={t("common-table-heading-5")}
                          value={formik.values.type}
                          onChange={(value) => {
                            formik.setFieldValue("type", value);
                          }}
                          isMulti={false}
                          menuList={typeList}
                          placeholder={t("please-select")}
                          name="type"
                          error={
                            Boolean(
                              formik?.errors?.type && formik?.touched?.type
                            )
                              ? formik.errors
                              : null
                          }
                        />
                      )}
                      {enteries
                        .slice(1, enteries?.length)
                        .map((item, index) => {
                          return (
                            <InputField
                              key={index}
                              type={item.type}
                              onChange={
                                item.type === "format-number"
                                  ? (value) =>
                                      formik.setFieldValue(item.name, value)
                                  : formik.handleChange
                              }
                              name={item.name}
                              value={
                                item.type === "format-number"
                                  ? formik.values[item.name]
                                  : formik.values[item.name] || ""
                              }
                              placeholder={item.placeholder}
                              label={item.label}
                              error={
                                Boolean(
                                  formik?.errors[item.name] &&
                                    formik?.touched[item.name]
                                )
                                  ? formik.errors
                                  : null
                              }
                            />
                          );
                        })}
                    </>
                  ) : type === "owner" ? (
                    enteries?.map((item, index) => {
                      return (
                        <InputField
                          key={index}
                          type={item.type}
                          // onChange={
                          //   item.type === "format-number"
                          //     ? (value) =>
                          //         formik.setFieldValue(item.name, value)
                          //     : formik.handleChange
                          // }
                          onChange={
                            item.type === "format-number"
                              ? (value) =>
                                  formik.setFieldValue(item.name, value)
                              : item.type === "date"
                              ? (value) =>
                                  formik.setFieldValue(
                                    "fixedInterestRate",
                                    value
                                      ? dayjs(value).format("YYYY-MM-DD")
                                      : null
                                  )
                              : formik.handleChange
                          }
                          // formik.setFieldValue("fixedInterestRate", value ? dayjs(value).format("YYYY-MM-DD") : null);

                          name={item.name}
                          // value={
                          //   item.type === "format-number"
                          //     ? formik.values[item.name]
                          //     : formik.values[item.name] || ""
                          // }

                          value={
                            item.type === "format-number"
                              ? formik.values[item.name]
                              : item.type === "date"
                              ? formik.values.fixedInterestRate
                                ? dayjs(
                                    formik.values.fixedInterestRate
                                  ).toDate()
                                : null
                              : formik.values[item.name] || ""
                          }
                          placeholder={item.placeholder}
                          label={item.label}
                          error={
                            Boolean(
                              formik?.errors[item.name] &&
                                formik?.touched[item.name]
                            )
                              ? formik.errors
                              : null
                          }
                        />
                      );
                    })
                  ) : (
                    enteries.slice(1, enteries?.length).map((item, index) => {
                      return (
                        <InputField
                          key={index}
                          type={item.type}
                          onChange={
                            item.type === "format-number"
                              ? (value) =>
                                  formik.setFieldValue(item.name, value)
                              : formik.handleChange
                          }
                          name={item.name}
                          value={
                            item.type === "format-number"
                              ? formik.values[item.name]
                              : formik.values[item.name] || ""
                          }
                          placeholder={item.placeholder}
                          label={item.label}
                          error={
                            item.type === "date"
                              ? null // Set error to null for "date" type, else use formik.errors
                              : Boolean(
                                  formik?.errors[item.name] &&
                                    formik?.touched[item.name]
                                )
                              ? formik.errors
                              : null
                          }
                        />
                      );
                    })
                  ))}
                {tabName === "insurance" && (
                  <InputField
                    label={t("input-18")}
                    onChange={selectInsuranceDocument}
                    name="document"
                    type="file"
                    error={
                      Boolean(
                        formik?.errors?.document && formik?.touched?.document
                      )
                        ? formik.errors
                        : null
                    }
                    docName={documentName}
                  />
                )}
              </FormControl>

              {btnLoader ? (
                <Button
                  disabled
                  sx={{
                    color: "color.brown",
                    padding: "8px 50px",
                    backgroundColor: "color.magentaLight2",
                    margin: "4rem auto 1rem auto",
                    fontWeight: "bold",
                    borderRadius: "15px",
                    opacity: "0.6",
                  }}
                >
                  <Oval
                    height="20"
                    width="20"
                    color="grey"
                    ariaLabel="loading"
                  />
                </Button>
              ) : (
                <Button
                  sx={{
                    color: "color.brown",
                    padding: "8px 50px",
                    backgroundColor: "color.magentaLight2",
                    margin: "4rem auto 1rem auto",
                    marginTop: `${
                      tabNames.some((el) => el === tabName) ? "auto" : "4rem"
                    }`,
                    fontWeight: "bold",
                    borderRadius: "15px",
                    textTransform: "initial",
                    "&:hover": {
                      backgroundColor: "color.magentaLight1",
                      boxShadow: "none",
                    },
                  }}
                  onClick={() => {
                    formik.handleSubmit(formik.values);
                  }}
                >
                  {t("save")}
                </Button>
              )}
            </Box>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default AddOwner;
